import { gql } from "@apollo/client";

export const GET_ACTIVE_MODULES = gql`
  query getactivemodules($active: Boolean) {
    getActiveModules(active: $active) {
      value
      label
    }
  }
`;

export const GET_SDWIS_REPORT_PAGE_DATA = gql`
  query ($umdId: String!) {
    getUserSdwisReportsByUmdId(umdId: $umdId) {
      umdId
      tables {
        reportId
        reportName
      }
    }
  }
`;

export const GET_APP_MENU = gql`
  query menu($menu: String!, $userRole: String) {
    getAppMenu(menu: $menu, userRole: $userRole) {
      value
      label
      route
      accessPortal
      accessStaff
    }
  }
`;

export const GET_COUNTY_LIST = gql`
  query getCounties {
    value
    label
  }
`;
